"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVideoDrawerType = exports.shouldVideoLimitBannerRender = exports.getDoesConversionAssetHaveNecessaryProperties = exports.logBadConversionAssetData = exports.getIsConversionAssetValid = exports.getHubLParamsForVideoPlayer = exports.getHubLVideoHubLTag = exports.isHubLVideo = exports.getHubLVideoPlayerIdFromFile = exports.getHubLVideoParamObjectFromFile = void 0;

var _Constants = require("../Constants");

var hubLVideoUtils = _interopRequireWildcard(require("FileManagerCore/utils/hubLVideo"));

var getHubLVideoParamObjectFromFile = function getHubLVideoParamObjectFromFile(file) {
  return hubLVideoUtils.getHubLVideoParamObjectFromFile(file);
};

exports.getHubLVideoParamObjectFromFile = getHubLVideoParamObjectFromFile;

var getHubLVideoPlayerIdFromFile = function getHubLVideoPlayerIdFromFile(file) {
  return hubLVideoUtils.getHubLVideoPlayerIdFromFile(file);
};

exports.getHubLVideoPlayerIdFromFile = getHubLVideoPlayerIdFromFile;

var isHubLVideo = function isHubLVideo(file) {
  return hubLVideoUtils.isHubLVideo(file);
};

exports.isHubLVideo = isHubLVideo;

var getHubLVideoHubLTag = function getHubLVideoHubLTag(params) {
  return hubLVideoUtils.getHubLVideoHubLTag(params);
};

exports.getHubLVideoHubLTag = getHubLVideoHubLTag;

var getHubLParamsForVideoPlayer = function getHubLParamsForVideoPlayer(params) {
  return hubLVideoUtils.getHubLParamsForVideoPlayer(params);
};

exports.getHubLParamsForVideoPlayer = getHubLParamsForVideoPlayer;

var getIsConversionAssetValid = function getIsConversionAssetValid(conversionAsset) {
  return hubLVideoUtils.getIsConversionAssetValid(conversionAsset);
};

exports.getIsConversionAssetValid = getIsConversionAssetValid;

var logBadConversionAssetData = function logBadConversionAssetData(failureMessage) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return hubLVideoUtils.logBadConversionAssetData(failureMessage, error);
};

exports.logBadConversionAssetData = logBadConversionAssetData;

var getDoesConversionAssetHaveNecessaryProperties = function getDoesConversionAssetHaveNecessaryProperties(conversionAsset) {
  return hubLVideoUtils.getDoesConversionAssetHaveNecessaryProperties(conversionAsset);
};

exports.getDoesConversionAssetHaveNecessaryProperties = getDoesConversionAssetHaveNecessaryProperties;

var shouldVideoLimitBannerRender = function shouldVideoLimitBannerRender(params) {
  var hasUserExceededVideoLimit = params.hasUserExceededVideoLimit,
      type = params.type,
      isVideoLimitBannerDismissed = params.isVideoLimitBannerDismissed;
  return type === _Constants.DrawerTypes.HUBL_VIDEO && !isVideoLimitBannerDismissed && hasUserExceededVideoLimit;
};

exports.shouldVideoLimitBannerRender = shouldVideoLimitBannerRender;

var isVideoDrawerType = function isVideoDrawerType(drawerType) {
  return drawerType === _Constants.DrawerTypes.HUBL_VIDEO || drawerType === _Constants.DrawerTypes.VIDEO;
};

exports.isVideoDrawerType = isVideoDrawerType;